import React from "react";
import {
    IconButton,
    Badge,
    Menu,
    MenuItem,
    Checkbox,
    ListItemText,
    ListItemIcon,
} from "@mui/material";
import { useAppSelector } from "../../../../framework/customStore";
import { useDispatch } from "react-redux";
import { FilterAlt } from "@mui/icons-material";

interface VehicleGroupFilterProps {
    selectedGroupIds: string[];
    setSelectedVehicleGroupIds: (selectedVehicleGroupIds: string[]) => void;
}

const VehicleGroupFilter: React.FC<VehicleGroupFilterProps> = ({
    selectedGroupIds,
    setSelectedVehicleGroupIds,
}) => {
    const dispatch = useDispatch();
    const vehicleGroups = useAppSelector((state) => state.vehicle.allVehicleGroups);

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleToggleGroup = (groupId: string) => {
        if (selectedGroupIds.includes(groupId)) {
            dispatch(setSelectedVehicleGroupIds(selectedGroupIds.filter((id) => id !== groupId)));
        } else {
            dispatch(setSelectedVehicleGroupIds([...selectedGroupIds, groupId]));
        }
    };

    return (
        <>
            <IconButton
                onClick={(e) => setAnchorEl(e.currentTarget)}
                color={selectedGroupIds.length > 0 ? "primary" : "default"}
            >
                <Badge
                    badgeContent={selectedGroupIds.length}
                    color="primary"
                    overlap="circular"
                    invisible={selectedGroupIds.length === 0}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                    }}
                >
                    <FilterAlt
                        color={selectedGroupIds.length === 0 ? "disabled" : "inherit"}
                    />
                </Badge>
            </IconButton>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
            >
                {vehicleGroups.map((group) => (
                    <MenuItem
                        key={group.id}
                        onClick={() => handleToggleGroup(group.id)}
                    >
                        <ListItemIcon>
                            <Checkbox
                                edge="start"
                                checked={selectedGroupIds.includes(group.id)}
                            />
                        </ListItemIcon>
                        <ListItemText primary={group.name} />
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default React.memo(VehicleGroupFilter);
